var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition",
        persistent: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0 d-flex flex-column merge-card" },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 px-2 py-0" },
            [
              _c("v-card-title", { staticClass: "deep-orange--text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.hasSource ? _vm.sourceConfig.group : "-") +
                    " "
                ),
              ]),
              _vm.targetConfig
                ? [
                    _c(
                      "span",
                      { staticClass: "grey--text text--lighten-1 mx-3" },
                      [_vm._v("|")]
                    ),
                    _c("span", { staticClass: "caption grey--text" }, [
                      _vm._v(_vm._s(_vm.targetOwner)),
                    ]),
                    _c(
                      "span",
                      { staticClass: "grey--text text--lighten-1 mx-3" },
                      [_vm._v("|")]
                    ),
                    _c("span", { staticClass: "caption grey--text" }, [
                      _vm._v(_vm._s(_vm._f("formatDate")(_vm.targetUpdated))),
                    ]),
                    _c(
                      "span",
                      { staticClass: "grey--text text--lighten-1 mx-3" },
                      [_vm._v("|")]
                    ),
                    _c(
                      "v-chip",
                      {
                        attrs: {
                          small: "",
                          label: "",
                          color: _vm.isTargetDeployed ? "green" : "red",
                          "text-color": "white",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isTargetDeployed ? "Deployed" : "Not Deployed"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { icon: "" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            2
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-4 mb-3" },
            [
              _c(
                "v-card",
                {
                  staticClass: "white--text px-0",
                  attrs: { elevation: "0", outlined: "", width: "100%" },
                },
                [
                  _c(
                    "v-card-actions",
                    { staticClass: "ma-0" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.getActiveColor(1),
                            outlined: "",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onPressTab(1)
                            },
                          },
                        },
                        [_vm._v(" My Configs ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.getActiveColor(2),
                            outlined: "",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onPressTab(2)
                            },
                          },
                        },
                        [_vm._v(" Pre Release Configs ")]
                      ),
                      _c(
                        "v-card",
                        {
                          staticClass: "white--text px-0 ml-2",
                          attrs: { elevation: "0", width: "100%" },
                        },
                        [
                          _c("v-autocomplete", {
                            staticClass: "ma-0 pa-0",
                            attrs: {
                              dense: "",
                              height: "30px",
                              items: _vm.getEndConfigs(),
                              outlined: "",
                              "item-text": "group",
                              "item-value": "uid",
                              "return-object": "",
                              "small-chips": "",
                              "deletable-chips": "",
                              "hide-details": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateInput()
                              },
                            },
                            model: {
                              value: _vm.targetConfig,
                              callback: function ($$v) {
                                _vm.targetConfig = $$v
                              },
                              expression: "targetConfig",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-0 mt-n2 flex-grow-1 min-h-0" },
            [
              _c(
                "v-card",
                {
                  staticClass: "mx-4 d-flex flex-column fill-height min-h-0",
                  attrs: { outlined: "", width: "100%" },
                },
                [
                  _vm.downloadData
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-grow-1 d-flex align-center justify-center",
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: { indeterminate: "", color: "primary" },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm.sourceConfig == null || _vm.targetConfig == null
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex-grow-1 d-flex align-center justify-center",
                          },
                          [
                            _c("v-card-title", { staticClass: "grey--text" }, [
                              _vm._v("Select a config to compare with"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "flex-grow-1 min-h-0 overflow-y-auto" },
                    [
                      _c(
                        "v-card-actions",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _c(
                            "v-list",
                            { attrs: { width: "100%", dense: "" } },
                            _vm._l(_vm.groups, function (group) {
                              return _c(
                                "v-list-group",
                                {
                                  key: group.name,
                                  attrs: { "append-icon": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "pa-0 mx-0" },
                                              [
                                                group.code === 0
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          color: "green",
                                                          outlined: "",
                                                        },
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            "mdi-check-circle"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticStyle: {
                                                              "margin-left":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(group.name)
                                                            ),
                                                          ]
                                                        ),
                                                        _c("v-spacer"),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          color:
                                                            _vm.getGroupColor(
                                                              group
                                                            ),
                                                          elevation: "0",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-alert-circle-outline"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-space-between",
                                                            staticStyle: {
                                                              width: "100%",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  group.name
                                                                ) +
                                                                " "
                                                            ),
                                                            _vm.groupHasSelection(
                                                              group
                                                            )
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " [A: " +
                                                                      _vm._s(
                                                                        _vm.getGroupSelectionCounts(
                                                                          group
                                                                        ).a
                                                                      ) +
                                                                      "] [B: " +
                                                                      _vm._s(
                                                                        _vm.getGroupSelectionCounts(
                                                                          group
                                                                        ).b
                                                                      ) +
                                                                      "] [C: " +
                                                                      _vm._s(
                                                                        _vm.getGroupSelectionCounts(
                                                                          group
                                                                        ).c
                                                                      ) +
                                                                      "] "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c("v-spacer"),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "ml-4 mr-4",
                                      attrs: { height: "40px", elevation: "0" },
                                    },
                                    [
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                color: "orange",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSelectaAll(
                                                    group,
                                                    "a"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  "mdi-checkbox-multiple-outline"
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                color: "blue",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSelectaAll(
                                                    group,
                                                    "b"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  "mdi-checkbox-multiple-outline"
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                small: "",
                                                icon: "",
                                                color: "grey",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeselectAll(
                                                    group
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-eraser"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(group.items, function (item) {
                                    return _c(
                                      "v-list-item",
                                      { key: item.uid },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          { staticClass: "pa-0" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "white--text ma-0 pa-0",
                                                attrs: {
                                                  color: _vm.getItemColor(item),
                                                  elevation: "0",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-5",
                                                    attrs: { size: "20" },
                                                  },
                                                  [_vm._v("mdi-alert-circle")]
                                                ),
                                                _c(
                                                  "h5",
                                                  { staticClass: "ml-3" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.name) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-spacer"),
                                                _c(
                                                  "v-checkbox",
                                                  {
                                                    attrs: {
                                                      value: _vm.checkedA(item),
                                                      color: "white",
                                                      light: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.checkboxUpdated(
                                                          item.group +
                                                            "/" +
                                                            item.uid,
                                                          "a",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                        attrs: {
                                                          slot: "label",
                                                        },
                                                        slot: "label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.labelA)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-checkbox",
                                                  {
                                                    staticClass: "ml-7",
                                                    attrs: {
                                                      value: _vm.checkedB(item),
                                                      color: "white",
                                                      light: "",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.checkboxUpdated(
                                                          item.group +
                                                            "/" +
                                                            item.uid,
                                                          "b",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                        attrs: {
                                                          slot: "label",
                                                        },
                                                        slot: "label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.labelB)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm.resolved[
                                                  item.group + "/" + item.uid
                                                ]?.c
                                                  ? _c(
                                                      "v-checkbox",
                                                      {
                                                        staticClass: "ml-7",
                                                        attrs: {
                                                          "input-value":
                                                            _vm.isCustomChecked(
                                                              item
                                                            ),
                                                          color: "white",
                                                          light: "",
                                                          disabled: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "white--text",
                                                            attrs: {
                                                              slot: "label",
                                                            },
                                                            slot: "label",
                                                          },
                                                          [_vm._v("CUSTOM")]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c("v-divider", {
                                                  staticClass: "ml-5",
                                                  staticStyle: {
                                                    "background-color": "white",
                                                  },
                                                  attrs: { vertical: "" },
                                                }),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "ml-2 mr-2",
                                                    attrs: {
                                                      icon: "",
                                                      color: "white",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showItemDetails(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { size: "22" } },
                                                      [_vm._v("mdi-merge")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text px-3",
                  attrs: {
                    disabled:
                      _vm.isNotResolved() ||
                      _vm.sourceConfig == null ||
                      _vm.targetConfig == null ||
                      _vm.downloadData,
                    color: "blue",
                    elevation: "0",
                  },
                  on: { click: _vm.onPressSaveToMyConfigs },
                },
                [
                  _vm._v(" Merge and save to My Configs "),
                  _c("v-icon", { staticClass: "ml-3" }, [
                    _vm._v("mdi-content-save"),
                  ]),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text px-3",
                  attrs: {
                    disabled: true || !_vm.ifCanDeploy(),
                    color: "green",
                    elevation: "0",
                  },
                  on: { click: _vm.onPressDeployToRelease },
                },
                [
                  _vm._v(" Deploy to Release "),
                  _c("v-icon", { staticClass: "ml-3" }, [
                    _vm._v("mdi-content-save-move"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }